import { Empty } from "components/Empty";
import FilterWithUnits from "components/FilterWithUnits";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const format = { unit: "meter", divideBy: 1000, decimals: 1 };

export const DraaicirkelFilter = ({ condensed }) => {
    const filterOptions = useFilter("draaicirkel");
    const [value, , onChange] = useField("draaicirkels");

    const options = filterOptions.map((o) => ({ id: o }));

    return (
        <Grid condensed={condensed}>
            <FilterWithUnits
                filterId="filter-draaicirkel"
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="draaicirkel"
                helpText="Maximaal"
                data={options}
                format={format}
            />
            <Empty />
        </Grid>
    );
};
